import Component from '../core/Component'

export const STATUS = {
    WARNING: 'is-warning',
    LIMIT: 'is-limit'
}

export default class CharCount extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            input: null,
            count: null
        }

        this.limit = parseInt(this.ref.input.maxlength || this.ref.count.dataset.limit || '100')
    }

    prepare() {
        this.ref.input.addEventListener('keydown', ::this.handleKeydown)
    }

    handleKeydown(event) {
        const count = this.limit - this.ref.input.value.length

        this.ref.count.innerText = count

        this.element.classList.toggle(STATUS.WARNING, count > 0 && count <=10 )
        this.element.classList.toggle(STATUS.LIMIT, count <= 0)
    }
}